export default __webpack_public_path__ + "static/media/power.f8b00b5c.png";